<div id="layoutDefault">
  <div id="layoutDefault_content">
    <main>
      <ng-content></ng-content>
    </main>
  </div>
  <div id="layoutDefault_footer">
    <sb-footer mode="complete" [classes]="footerClasses"></sb-footer>
  </div>
</div>
